import React, { useState, useEffect, useRef } from 'react';
import { PrivatePageLayout, PageHeader, PageCard } from '../../components/PrivatePage';
import Toast from '../../components/Toast/Toast';
import LogModal from '../../components/Logs/LogModal';
import { AppButton } from '../../components/AppButton/AppButton';
import { getSettings, updateSettings } from '../../services/SettingsService';

function Settings() {
    const confirmPassword = useRef('');
    const [settings, setSettings] = useState({});
    const [notification, setNotification] = useState({});

    useEffect(() => {
        getSettings()
            .then((result) => setSettings(result))
            .catch((err) => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }, []);

    function onInputChange(event) {
        setSettings((prevState) => ({ ...prevState, [event.target.id]: event.target.value }));
    }

    function onFormSubmit() {
        if ((settings.password || confirmPassword.current.value)
            && settings.password !== confirmPassword.current.value) {
            return setNotification({ type: 'error', text: 'New Password and Confirm Password must match.' });
        }

        updateSettings(settings)
            .then((result) => {
                if (result) setNotification({ type: 'success', text: 'Settings saved successfully!' });
                else setNotification({ type: 'error', text: result });
            })
            .catch((err) => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }

    return (
        <PrivatePageLayout>
            <PageHeader
                eyebrow="Admin"
                title="System settings"
                subtitle="Admin account, passwords, and alert integrations."
                actions={(
                    <AppButton
                        id="btnLogs"
                        variant="secondary"
                        size="md"
                        data-bs-toggle="modal"
                        data-bs-target="#modalLogs"
                    >
                        System logs
                    </AppButton>
                )}
            />

            <PageCard title="Personal settings" description="Email, phone, and password for this admin account.">
                <div className="private-page-grid">
                    <div className="private-page-field">
                        <label htmlFor="email">Email</label>
                        <input className="form-control" id="email" type="email" placeholder="name@company.com" defaultValue={settings.email} onChange={onInputChange} />
                    </div>
                    <div className="private-page-field">
                        <label htmlFor="phone">Cellphone</label>
                        <input className="form-control" id="phone" type="text" placeholder="+1 51 123456789" defaultValue={settings.phone} onChange={onInputChange} />
                    </div>
                    <div className="private-page-field">
                        <label htmlFor="password">New password</label>
                        <input className="form-control" id="password" type="password" placeholder="Enter your new password" onChange={onInputChange} />
                    </div>
                    <div className="private-page-field">
                        <label htmlFor="confirmPassword">Confirm password</label>
                        <input ref={confirmPassword} className="form-control" id="confirmPassword" type="password" placeholder="Your new password again" />
                    </div>
                </div>
                <div className="private-page-actions">
                    <AppButton variant="primary" size="md" onClick={onFormSubmit}>Save</AppButton>
                </div>
            </PageCard>

            <PageCard title="Alert settings" description="SendGrid, Twilio, and Telegram credentials used for system alerts.">
                <div className="private-page-field">
                    <label htmlFor="sendGridKey">SendGrid API key</label>
                    <input className="form-control" id="sendGridKey" type="password" placeholder="Enter the SendGrid API Key" defaultValue={settings.sendGridKey} onChange={onInputChange} />
                </div>
                <div className="private-page-grid">
                    <div className="private-page-field">
                        <label htmlFor="twilioPhone">Twilio phone</label>
                        <input className="form-control" id="twilioPhone" type="text" placeholder="Enter the Twilio Phone Number" defaultValue={settings.twilioPhone} onChange={onInputChange} />
                    </div>
                    <div className="private-page-field">
                        <label htmlFor="twilioSid">Twilio SID</label>
                        <input className="form-control" id="twilioSid" type="text" placeholder="Enter the Twilio SID" defaultValue={settings.twilioSid} onChange={onInputChange} />
                    </div>
                    <div className="private-page-field">
                        <label htmlFor="twilioToken">Twilio token</label>
                        <input className="form-control" id="twilioToken" type="password" placeholder="Enter the Twilio Token" defaultValue={settings.twilioToken} onChange={onInputChange} />
                    </div>
                    <div className="private-page-field">
                        <label htmlFor="telegramBot">Telegram bot name</label>
                        <input className="form-control" id="telegramBot" type="text" placeholder="Enter the Telegram Bot Name" defaultValue={settings.telegramBot} onChange={onInputChange} />
                    </div>
                    <div className="private-page-field">
                        <label htmlFor="telegramToken">Telegram bot token</label>
                        <input className="form-control" id="telegramToken" type="password" placeholder="Enter the Telegram Bot Token" defaultValue={settings.telegramToken} onChange={onInputChange} />
                    </div>
                    <div className="private-page-field">
                        <label htmlFor="telegramChat">Telegram chat ID</label>
                        <input className="form-control" id="telegramChat" type="text" placeholder="Enter the Telegram Chat ID" defaultValue={settings.telegramChat} onChange={onInputChange} />
                    </div>
                </div>
                <div className="private-page-actions">
                    <AppButton variant="primary" size="md" onClick={onFormSubmit}>Save</AppButton>
                </div>
            </PageCard>

            <Toast text={notification.text} type={notification.type} />
            <LogModal file="system" />
        </PrivatePageLayout>
    );
}

export default Settings;